import { useState } from "react";
import BlockMain from "./BlockMain";
import BlockNotifications from "./BlockNotifications";
import BlockApi from "./BlockApi";

import { faArrowUpRightFromSquare, faBell, faBuilding, faCode } from "@fortawesome/free-solid-svg-icons";
import TabBar from "../../../components/ui/TabBar";

function Index() {

    const [tab, setTab] = useState([
        { id_tab: 1, name: "Основное", icon: faBuilding, showCount: false }
        , { id_tab: 2, name: "Уведомления", icon: faBell, showCount: false }
        , { id_tab: 3, name: "API", icon: faCode, showCount: false }
    ]);
    const [tabSelected, setTabSelected] = useState(1);
    return (
        <div className='admin_content'>
            <div className="mb-20 mt-20">
                <TabBar tabData={tab} tabSelected={tabSelected} tabClikHandler={setTabSelected} showAdd={false} showFilter={false} />
            </div>
            {tab.map(tab => (
                <div key={tab.id_tab} className={tab.id_tab !== tabSelected ? "d-none" : ""}>
                    {tab.id_tab === 1 && (
                        <BlockMain />
                    )}
                    {tab.id_tab === 2 && (
                        <BlockNotifications />
                    )}
                    {tab.id_tab === 3 && (
                        <BlockApi />
                    )}
                </div>
            ))}
        </div>

    )
}
export default Index;